exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#row{\r\n    padding-top: 30px;\r\n}\r\n\r\n#row1{\r\n    padding-top: 10px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n}\r\n\r\n.btn-primary{\r\n    background-color: #5d9cec !important;\r\n}\r\n\r\n.paddtop{\r\n    padding-top: 20px !important;\r\n    padding-left: 20px;\r\n}\r\n\r\ntable tr td, table tr th, table {\r\n    border-color: darkgray !important;\r\n}\r\n\r\nlabel{\r\n    font-size: 16px !important;\r\n}\r\n\r\ntable tr td, table tr th{\r\n    padding: 10px !important;\r\n}\r\n\r\n.form-control {\r\n    width: 90% !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/units/units.component.css
// module id = ../../../../../src/app/units/units.component.css
// module chunks = main